module.exports = __webpack_public_path__ + "static/img/jtsl.6b0f7df0.png";